'use es6';

import actionTypes from 'ContentEditorUI/redux/actions/inpageActionTypes';

// Note, these are not treated as real Redux actions. They are structured like actions,
// but they will be received as post message events in the parent.
// More info in inpageActionTypes.js

export const documentClick = () => {
  return {
    type: actionTypes.DOCUMENT_CLICK
  };
};
export const hideModuleHoverMenu = () => {
  return {
    type: actionTypes.HIDE_MODULE_HOVER_MENU
  };
};
export const iframeWindowResize = bodyHeight => {
  return {
    type: actionTypes.IFRAME_WINDOW_RESIZE,
    bodyHeight
  };
};
export const positionModuleMenu = positionInfo => {
  return {
    type: actionTypes.POSITION_MODULE_MENU,
    positionInfo
  };
};